(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('PayOrder', PayOrder)
        .factory('PaidGiftSetting', PaidGiftSetting);

    PayOrder.$inject = ['$resource'];
    PaidGiftSetting.$inject = ['$resource'];

    function PayOrder ($resource) {
        var resourceUrl =  'manager/' + 'api/pay-orders/:path/:id';

        return $resource(resourceUrl, {}, {

            'getAllByCondition': {
                params:{
                    path:"getAllByCondition"
                },
                method: 'POST'
            },
            'byCondition': {
                params:{
                    path:"byCondition"
                },
                method: 'POST'
            },
            "createPayOrder": {
                params:{
                    path:"createPayOrder"
                },
                method: 'GET'
            },
            "aliPay": {
                params:{
                    path:"aliPay"
                },
                method: 'GET'
            },
            "createPayOrder2": {
                params:{
                    path:"createPayOrder2"
                },
                method: 'POST'
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    function PaidGiftSetting ($resource) {
        var resourceUrl =  'manager/' + 'api/paid-gift-settings/:path/:id';

        return $resource(resourceUrl, {}, {

            'getAllByCondition': {
                params:{
                    path:"getAllByCondition"
                },
                method: 'POST'
            },
            'byCondition': {
                params:{
                    path:"byCondition"
                },
                method: 'POST'
            },
            'query': { method: 'GET'},
            'delete': { method: 'DELETE'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
